import {ActivatedRouteSnapshot} from '@angular/router';
import {RouteOption} from './route-option';

export class BooleanRouteOption extends RouteOption<boolean> {
	constructor(
		key: string,
		route: ActivatedRouteSnapshot,
		defaultValue: boolean,
	) {
		super(
			key,
			route,
			new Set([true, false]),
			defaultValue
		);
	}

	override toString(value: boolean): string {
		return value?.toString();
	}

	override toValue(value?: string): boolean | undefined {
		if (value === 'true') {
			return true;
		}  else if (value === 'false') {
			return false;
		}

		return undefined;
	}
}
